import { lazy } from "react";

/* eslint-disable prettier/prettier */

import { definedRouteTypes, definedFooterRoutes } from "./api/api";
import IRoute from "./interfaces/IRoute";

const AllCompaniesFrontPage = lazy(() => import("./components/pages/AllOfTypePages/AllCompaniesFrontPage"));
const AllOrganizationsFrontPage = lazy(() => import("./components/pages/AllOfTypePages/OrganizationsFrontPage"));
const PartnersFrontPage = lazy(() => import("./components/pages/AllOfTypePages/PartnersFrontPage"));
const OffersPage = lazy(() => import("./components/pages/AllOfTypePages/OffersFrontPage"));
const MadeInLatviaPage = lazy(() => import('./components/pages/AllOfTypePages/MadeInLatviaFrontPage'));
const LatviansAroundWorldPage = lazy(() => import('./components/pages/AllOfTypePages/LatviansAroundWorldFrontPage'));
const TemplateSitePage = lazy(() => import("./components/templateSite/TemplateSitePage/TemplateSitePage"));
const SinglePage = lazy(() => import("./components/pages/SinglePages/SinglePage"));
const FooterPage = lazy(() => import("./components/staticPages/StaticPage"));
const Contacts = lazy(() => import("./components/staticPages/Contacts"));
const SocialLoginPage = lazy(() => import("./components/pages/SocialLoginPage"));
const GalleryPage = lazy(() => import("./components/pages/AllOfTypePages/GalleryFrontPage"));
const VideoPage = lazy(() => import("./components/pages/AllOfTypePages/VideoFrontPage"));
const AllOrganizationNewsPage = lazy(() => import("./components/pages/AllOfTypePages/OrganizationNewsFrontPage"));
const CountryPage = lazy(() => import("./components/pages/CountryPage"));
const BasicFilter = lazy(() => import("./components/pages/QueryPages/BasicFilters"));
const AllNewsPages = lazy(() => import("./components/pages/AllOfTypePages/AllNewsFrontPage"));
const AllExclusiveNewsPages = lazy(() => import("./components/pages/AllOfTypePages/AllExclusiveNewsFrontPage"));
const AllDiasporeNewsPage = lazy(() => import("./components/pages/AllOfTypePages/DiasporeNewsFrontPage"));
const SearchPage = lazy(() => import("./components/pages/QueryPages/SearchPage"));
const AllEventsFrontPage = lazy(() => import("./components/pages/AllOfTypePages/AllEventsFrontPage"));
const AllRegionNewsFrontPage = lazy(() => import("./components/pages/AllOfTypePages/AllRegionNewsFrontPage"));
const HomePage = lazy(() => import("./components/pages/HomePage"));
const EditSinglePage = lazy(() => import("./components/pages/EditSinglePage"));
const SelfEmployedProfile = lazy(() => import("./components/pages/SelfEmployedProfile"));
const SingleRedirectPage = lazy(() => import("./components/pages/SinglePages/SingleRedirectPage"));
const UserPage = lazy(() => import("./components/pages/UserPage/UserPage"));
const ForOrganizations = lazy(() => import("./components/staticPages/ForOrganizations"));
const ForCompanies = lazy(() => import("./components/staticPages/ForCompanies"));
const AllMediaLinkPage = lazy(() => import("./components/pages/AllOfTypePages/AllMediaLinkPage"));
const AllMediaSourcePage = lazy(() => import("./components/pages/AllOfTypePages/AllMediaSourcePage"));
const NewsletterPage = lazy(() => import("./components/pages/NewsletterPage"));
const AgencyPage = lazy(() => import("./components/pages/AllOfTypePages/AgencyPage"));
// TODO: fix any
function routeMaker(name: string, path: string, component?: any) {
  const route: IRoute = {
    name,
    path,
    component,
  };
  return route;
}
// !This is an exceptional route, goes above everything else
export const templateSiteRoute = routeMaker("templateSite", `/${definedRouteTypes.organizations}/:organization/:page?/:subPage?`, TemplateSitePage);
export const templateCompanySiteRoute = routeMaker("templateCompanySite", `/${definedRouteTypes.companies}/:organization/:page?/:subPage?`, TemplateSitePage);
export const templateSiteVideo = routeMaker("Video", "video");
export const templateSiteEvents = routeMaker("Notikumi", "notikumi");
export const templateSiteNews = routeMaker("Jaunumi", "jaunumi");
export const templateSiteGallery = routeMaker("Galerija", "galerija");

export const home = routeMaker("home", "/", HomePage);
export const newsletter = routeMaker("home", "/apkartraksts", NewsletterPage);

export const companyRoute = routeMaker("Companies", `/${definedRouteTypes.companies}`, AllCompaniesFrontPage);
export const organizationRoute = routeMaker("Orgs", `/${definedRouteTypes.organizations}`, AllOrganizationsFrontPage);
export const partnerOrganizationsRoute = routeMaker("Partners", `/${definedRouteTypes.partnerOrganizations}`, PartnersFrontPage)
export const offers = routeMaker("Offers", `/${definedRouteTypes.offers}`, OffersPage);
export const madeInLatvia = routeMaker("MadeInLatvia", `/${definedRouteTypes.madeInLatvia}`, MadeInLatviaPage);
export const latviansAroundWorld = routeMaker("LatviansAroundWorld", `/${definedRouteTypes.latviansAroundWorld}`, LatviansAroundWorldPage);
export const allDiasporeNews = routeMaker("DiasporeNewsRoute", `/${definedRouteTypes.diasporeNews}`, AllDiasporeNewsPage);
export const allRegionNews = routeMaker("AllRegionNewsFrontPage", `/${definedRouteTypes.regionNews}`, AllRegionNewsFrontPage);
export const allOrganizationNewsPage = routeMaker("OrganizationNewsRoute", `/${definedRouteTypes.organizationNews}`, AllOrganizationNewsPage);
export const galleries = routeMaker("GalleriesRoute", `/${definedRouteTypes.imageGallery}`, GalleryPage);
export const videoNews = routeMaker("VideoNewsRoute", `/${definedRouteTypes.videoNews}`, VideoPage);
export const socialLogin = routeMaker("social", "/social/facebook", SocialLoginPage);
export const mediaLinkPageRoute = routeMaker("AllMediaLinkPage", `/iszina`, AllMediaLinkPage);
export const mediaSourcePageRoute = routeMaker("AllMediaSourcePage", `/mediji`, AllMediaSourcePage);
export const allExclusiveNews = routeMaker("AllExclusiveNews", `/${definedRouteTypes.exclusive}`, AllExclusiveNewsPages);
export const externalAgency = routeMaker("ExternalAgency", "/agentura", AgencyPage);

// footer routes
export const aboutUs = routeMaker("Footer.AboutUs", `/${definedFooterRoutes.about}`, FooterPage);
export const contact = routeMaker("Footer.Contacts", `/${definedFooterRoutes.contacts}`, Contacts);
export const policy = routeMaker("Footer.Policy", `/${definedFooterRoutes.tos}`, FooterPage);
export const instructions = routeMaker("Footer.Instructions", `/${definedFooterRoutes.instructions}`, FooterPage);
export const forOrganizations = routeMaker("Footer.ForOrganisations", `/${definedFooterRoutes.forOrganizations}`, ForOrganizations);
export const forCompanies = routeMaker("Footer.ForCompanies", `/${definedFooterRoutes.forCompanies}`, ForCompanies);
export const supporters = routeMaker("Footer.Supporters", `/${definedFooterRoutes.partners}`, FooterPage);
export const nightingale = routeMaker("Footer.Nightingale", `/${definedFooterRoutes.nightingale}`, FooterPage);

// type routes
export const allNews = routeMaker("AllNews", `/${definedRouteTypes.editorialNews}`, AllNewsPages);
export const allEvents = routeMaker("Notikumi", `/${definedRouteTypes.events}`, AllEventsFrontPage);

// query routes
export const searchPage = routeMaker("SearchPage", "/search", SearchPage);
export const singleSelfEmployedPage = routeMaker("singleSelfEmployedPage", `/${definedRouteTypes.selfEmployed}/:slug`, SelfEmployedProfile);
export const singleNewsPage = routeMaker("singleNewsPage", `/:type/:slug`, SinglePage);
export const redirectPage = routeMaker("redirectRoutes", "/:type/:redirectType/:slug", SingleRedirectPage);
export const simpleFilterPage = routeMaker("Filters", `/:type/${definedRouteTypes.filter}`, BasicFilter);
export const countryRoutes = routeMaker("countryRoutes", "/:valsts", CountryPage);
export const editRoutes = routeMaker("editRoutes", "/:type/:slug/edit", EditSinglePage);
export const profileRoutes = routeMaker("ProfileRoutes", `/lietotajs`, UserPage);

export const footerRoutes: IRoute[] = [
  aboutUs,
  contact,
  policy,
  forOrganizations,
  forCompanies,
  instructions,
  supporters,
  nightingale,
];

export const headerRoutes: IRoute[] = [
  allExclusiveNews,
  allNews,
  externalAgency,
  latviansAroundWorld,
  allEvents,
  // companyRoute,
  // organizationRoute,
  // madeInLatvia,
];

export const mainRoutes: IRoute[] = [
  allExclusiveNews,
  allNews,
  externalAgency,
  allEvents,
  allExclusiveNews,
  companyRoute,
  organizationRoute,
  galleries,
  videoNews,
  offers,
  madeInLatvia,
  latviansAroundWorld,
  allOrganizationNewsPage,
  allDiasporeNews,
  mediaLinkPageRoute,
  mediaSourcePageRoute,
  allRegionNews,

];

export const mobileHeaderRoutes = [allExclusiveNews, allNews, externalAgency];

export const redirects = [
  ["/103", "/irija"],
  ["/110", "/islande"],
  ["/111", "/italija"],
  ["/123", "/dienvidkoreja"],
  ["/13", "/austrija"],
  ["/14", "/australija"],
  ["/167", "/niderlande"],
  ["/168", "/norvegija"],
  ["/185", "/portugale"],
  ["/198", "/zviedrija"],
  ["/226", "/turcija"],
  ["/231", "/ukraina"],
  ["/234", "/asv"],
  ["/32", "/brazilija"],
  ["/39", "/kanada"],
  ["/3", "/apvienotie-arabu-emirati"],
  ["/44", "/sveice"],
  ["/57", "/cehija"],
  ["/58", "/vacija"],
  ["/60", "/danija"],
  ["/69", "/spanija"],
  ["/71", "/somija"],
  ["/78", "/lielbritanija"],
  ["/events/:slug", `/${definedRouteTypes.events}/:slug`],
  ["/article/:slug", `/${definedRouteTypes.editorialNews}/:slug`],
  ["/raksti/:slug", `/${definedRouteTypes.editorialNews}/:slug`],
  ["/video/:slug", `/${definedRouteTypes.videoNews}/:slug`],
  ["/lapas/:slug", `/${definedRouteTypes.organizations}/:slug`],
  ["/jaunumi/raksts/:slug", `/${definedRouteTypes.editorialNews}/:slug`],
  ["/notikumi/skatit/:slug", `/${definedRouteTypes.events}/:slug`],
];
const routes: IRoute[] = [
  home,
  newsletter,
  allNews,
  allExclusiveNews,
  simpleFilterPage,
  allDiasporeNews,
  allOrganizationNewsPage,
  galleries,
  videoNews,
  externalAgency,
  allEvents,
  allRegionNews,
  searchPage,
  companyRoute,
  organizationRoute,
  partnerOrganizationsRoute,
  offers,
  madeInLatvia,
  latviansAroundWorld,
  socialLogin,
  aboutUs,
  contact,
  mediaLinkPageRoute,
  mediaSourcePageRoute,
  policy,
  instructions,
  forCompanies,
  forOrganizations,
  supporters,
  nightingale,
  singleSelfEmployedPage,
  countryRoutes,
  editRoutes,
  redirectPage, // Its important that this page is higher that singleNewsPage
  singleNewsPage,
];

export default routes;
